import { z } from 'zod';

/** Todo payload de fila carrega o `requestId` de origem; nunca o Actor (T01 R-3). */
export const ComRequestId = z.object({ requestId: z.string().min(1) });

export interface JobContract<S extends z.ZodType = z.ZodType> {
  readonly name: string;
  readonly schema: S;
}

/** Fila `<dominio>.<acao>` (kebab pt-BR) com o Zod do payload, compartilhado entre `enqueue` e worker. */
export const defineJobContract = <const N extends string, S extends z.ZodType>(c: { name: N; schema: S }) => c;
